import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { addParamsToUrl } from 'utils/query';
import { BaseResponse, UserAuditEvent, PaginationResponse } from 'types';

import { apiQuery } from '../../query';

import { UserAuditEventListRequest } from './types';

const tagType = 'USER_AUDIT_EVENT';

export const userAuditEventsApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'userAuditEventsApi',
  endpoints: (build) => ({
    list: build.query<
      PaginationResponse<UserAuditEvent>,
      UserAuditEventListRequest | void
    >({
      providesTags: [tagType],
      transformResponse: (
        response: BaseResponse<PaginationResponse<UserAuditEvent>>
      ) => response.data,
      query: (params) => ({
        method: 'get',
        url: addParamsToUrl(URL.AUDIT_EVENTS, params || undefined, {
          preserveNull: true,
        }),
      }),
    }),
  }),
});

export const { useLazyListQuery } = userAuditEventsApi;
export type { UserAuditEventListRequest } from './types';
